module.exports = __webpack_public_path__ + "static/img/image (3).0ae287ba.png";